// BOLDE-owned (house) — safe to edit on the draft; follow lp/docs/NAMING-STANDARD.md.
(function () {
  // Tells the owned cart drawer (assets/bcart.js) about an add it did not make, via the
  // bcart:refresh event, so it opens after a buy-box Add to Cart. Not sent through Dawn's
  // pub/sub: quick-add-bulk.js and quick-order-list.js read event.cartData.items unguarded.
  function announceCartChange() {
    document.dispatchEvent(new CustomEvent('bcart:refresh', { detail: { source: 'bolde-cart-drawer' } }));
  }

  // Re-render the BOLDE header's cart count after a mutation, using the Section Rendering API for just
  // the section(s) that hold `.bolde_header-buttons`. Pages without that element (the Dawn header, where
  // Rebuy/bcart update the bubble themselves) skip the request. If it fails, fetch the whole page instead.
  function parseFragment(html) {
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    return tpl.content;
  }

  function legacyHeaderRefresh() {
    fetch(window.location.pathname, { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var fresh = parseFragment(html).querySelector('.bolde_header-buttons');
        if (!fresh) return;
        document.querySelectorAll('.bolde_header-buttons').forEach(function (el) {
          el.innerHTML = fresh.innerHTML;
        });
      });
  }

  function sectionOf(el) {
    return el.closest('[id^="shopify-section-"]');
  }

  function refreshCartDrawer() {
    announceCartChange();

    const targets = Array.prototype.slice.call(document.querySelectorAll('.bolde_header-buttons'));
    if (!targets.length) return;

    const ids = [];
    let unsectioned = false;
    targets.forEach(function (el) {
      const wrap = sectionOf(el);
      if (!wrap) { unsectioned = true; return; }
      const id = wrap.id.replace('shopify-section-', '');
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    // The Section Rendering API takes at most 5 ids per request.
    if (unsectioned || ids.length > 5) {
      legacyHeaderRefresh();
      return;
    }

    // fetch, not $.ajax/$.getJSON: jQuery's JSON Accept header makes Shopify answer
    // with the page resource ({"page":{...}}) instead of the rendered sections.
    fetch(window.location.pathname + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('sections ' + res.status);
        return res.json();
      })
      .then(function (sections) {
        if (!sections || !ids.some(function (id) { return sections[id]; })) throw new Error('sections missing');
        const parsed = {};
        targets.forEach(function (el) {
          const wrap = sectionOf(el);
          const id = wrap.id.replace('shopify-section-', '');
          const html = sections && sections[id];
          if (!html) return;
          parsed[id] = parsed[id] || parseFragment(html).querySelectorAll('.bolde_header-buttons');
          const index = Array.prototype.indexOf.call(wrap.querySelectorAll('.bolde_header-buttons'), el);
          const fresh = parsed[id][index];
          if (fresh) el.innerHTML = fresh.innerHTML;
        });
      })
      .catch(legacyHeaderRefresh);
  }

  // rebuy.js loads async, so an Add to Cart can land before Smart Cart exists (slow network, ad blocker,
  // Rebuy outage). If bcart is present it opens itself; if Smart Cart was ready at add time Rebuy opens
  // itself. Only when neither is there do we wait for Smart Cart (up to REBUY_WAIT_MS), else go to /cart.
  var REBUY_WAIT_MS = 4000;

  function rebuyReady() {
    var sc = window.Rebuy && window.Rebuy.SmartCart;
    return !!(sc && typeof sc.show === 'function');
  }

  function bcartPresent() {
    return !!document.getElementById('bcart-root');
  }

  function showRebuyCart() {
    var R = window.Rebuy;
    if (R.Cart && typeof R.Cart.fetchCart === 'function') {
      R.Cart.fetchCart(function () { R.SmartCart.show(); });
    } else {
      R.SmartCart.show();
    }
  }

  function goToCartPage() {
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }

  // Shows Smart Cart once it is ready, or goes to /cart after REBUY_WAIT_MS. Acts exactly once.
  // onDone (optional) runs just before the cart shows or the page changes, e.g. to stop a spinner.
  function openCartWhenReady(onDone) {
    if (rebuyReady()) { if (onDone) onDone(); showRebuyCart(); return; }
    var done = false;
    var start = Date.now();
    function finish(useRebuy) {
      if (done) return;
      done = true;
      if (onDone) onDone();
      document.removeEventListener('rebuy:smartcart.ready', onReady);
      document.removeEventListener('rebuy:smartcart.init', onReady);
      if (useRebuy) showRebuyCart(); else goToCartPage();
    }
    function onReady() { if (rebuyReady()) finish(true); }
    document.addEventListener('rebuy:smartcart.ready', onReady);
    document.addEventListener('rebuy:smartcart.init', onReady);
    (function poll() {
      if (done) return;
      if (rebuyReady()) return finish(true);
      if (Date.now() - start >= REBUY_WAIT_MS) return finish(false);
      setTimeout(poll, 100);
    })();
  }

  // Call after a successful on-page add. rebuyAtAdd = rebuyReady() at click time: if Smart Cart was up, Rebuy saw the add.
  function ensureCartVisible(rebuyAtAdd) {
    if (bcartPresent() || rebuyAtAdd) return;
    openCartWhenReady();
  }

  function afterAdd(rebuyAtAdd) {
    refreshCartDrawer();
    ensureCartVisible(rebuyAtAdd);
  }

  // Header cart icon. bcart, when on, takes these clicks in the capture phase.
  // Rebuy loads just after first paint, so an early tap used to land on /cart. Now it waits for Smart Cart
  // (spinner on the icon, up to REBUY_WAIT_MS) and only then falls back to /cart.
  document.addEventListener('click', function (evt) {
    var icon = evt.target.closest && evt.target.closest('.bolde_header-cart-icon, .header__icon--cart');
    if (!icon) return;
    evt.preventDefault();
    if (rebuyReady()) { window.Rebuy.SmartCart.show(); return; }
    if (!setBusy(icon, true)) return;
    openCartWhenReady(function () { setBusy(icon, false); });
  });

  /* Line-item tagging: every on-page Add to Cart stamps hidden properties on its lines so orders show
     where the item was added. Shopify hides "_" properties from shoppers (cart, checkout, emails); the
     team sees them on the order. Values match the live theme's (2026-10-09) so reports keep working:
       _added_from  buy_section        bottle(s) from the buy box Add to Cart (incl. bundle builder, sticky bar)
                    buy_section_addon  add-ons ticked in the buy box, or added with their own ADD button
                    pdp_classic        single-product buy box (accessory product pages; live: bolde_product_classic)
                    pdp_accessories_section  the PDP Accessories row
                    upsell_carousel    the accessory page's "pairs well with" carousel (new; untagged on live)
       _page        page handle, product handle, collection handle, 'home', else the page type (live's Liquid)
     A placement names itself with data-added-from="<value>" on the button or an ancestor; otherwise the
     handler's default applies. New products need nothing. A new button that reuses an existing class is
     covered; a new add-to-cart script calls window.BoldeCartTag.props(el, '<default>') for each line. */
  function pageKey() {
    var el = document.querySelector('[data-bolde-page]');
    var v = el && el.getAttribute('data-bolde-page');
    if (v) return v;
    var parts = window.location.pathname.split('/').filter(Boolean);
    var keys = ['products', 'pages', 'collections'];
    for (var i = 0; i < keys.length; i++) {
      var at = parts.indexOf(keys[i]);
      if (at > -1 && parts[at + 1]) return decodeURIComponent(parts[at + 1]);
    }
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page;
    if (meta && meta.pageType) return meta.pageType === 'home' ? 'home' : meta.pageType;
    return (!parts.length || (parts.length === 1 && /^[a-z]{2}(-[a-z]{2})?$/i.test(parts[0]))) ? 'home' : parts[0];
  }

  function lineProps(el, fallback) {
    var holder = el && el.closest ? el.closest('[data-added-from]') : null;
    var from = (holder && holder.getAttribute('data-added-from')) || fallback;
    if (!from) return null;
    return { _added_from: from, _page: pageKey() };
  }

  // A line for /cart/add.js, tagged. Leaves the line untouched if it already carries _added_from.
  function tagLine(line, el, fallback) {
    var p = lineProps(el, fallback);
    if (!p) return line;
    line.properties = line.properties || {};
    if (!line.properties._added_from) {
      line.properties._added_from = p._added_from;
      line.properties._page = p._page;
    }
    return line;
  }

  // Add-ons ticked in the buy box: one line per variant (Swiper loop clones and repeats skipped).
  function addonLines(scope) {
    var seen = {};
    var lines = [];
    (scope || document).querySelectorAll('.bb-addons_container.v2 .bb-addons_cell.active:not(.swiper-slide-duplicate)').forEach(function (cell) {
      var id = cell.getAttribute('data-id');
      if (!id || seen[id]) return;
      seen[id] = true;
      lines.push(tagLine({ id: id, quantity: 1 }, cell, 'buy_section_addon'));
    });
    return lines;
  }

  window.BoldeCartTag = { props: lineProps, tagLine: tagLine, addonLines: addonLines, page: pageKey };

  // Spinner while an add is in flight: .lp-busy (ring drawn by assets/bolde-sitewide.css) and aria-busy.
  // Returns false when the button is already busy, so a double tap never adds twice. The buy box's
  // sticky bar mirrors the main button's state (sections/lp-buybox.liquid).
  function setBusy(el, on) {
    if (!el) return true;
    if (on && el.classList.contains('lp-busy')) return false;
    el.classList.toggle('lp-busy', on);
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
    return true;
  }
  window.BoldeCartBusy = setBusy;

  ['rebuy:smartcart.line-item-increase', 'rebuy:smartcart.line-item-decrease', 'rebuy:smartcart.line-item-removed'].forEach(function (name) {
    document.addEventListener(name, refreshCartDrawer);
  });

  // Add-to-cart buttons of the buy box and house sections. They use jQuery, which the
  // layout loads only on pages with those sections; other pages keep the header icon above.
  if (!window.jQuery) return;
  jQuery(function ($) {
    $('.bolde_upsell-atc').click(function (evt) {
      evt.preventDefault();
      var btn = this;
      if (!setBusy(btn, true)) return;
      var rebuyAtAdd = rebuyReady();
      var currentId = $(this).attr('data-id');
      var currentQty = 1;
      var data;
      data = tagLine({
        id: currentId,
        quantity: currentQty,
      }, this, 'upsell_carousel');
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          setBusy(btn, false);
          afterAdd(rebuyAtAdd);
        },
        error: function () {
          setBusy(btn, false);
          alert('Error adding item to the cart.');
        }
      });
    });

    $('.bolde_access-btn').click(function (evt) {
      evt.preventDefault();
      var btn = this;
      if (!setBusy(btn, true)) return;
      var rebuyAtAdd = rebuyReady();
      var currentId = $(this).attr('data-id');
      var currentQty = 1;
      var data;
      data = tagLine({
        id: currentId,
        quantity: currentQty,
      }, this, 'pdp_accessories_section');
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          setBusy(btn, false);
          afterAdd(rebuyAtAdd);
        },
        error: function () {
          setBusy(btn, false);
          alert('Error adding item to the cart.');
        }
      });
    });

    $('.bb-addon_btn').click(function () {
      var btn = this;
      if (!setBusy(btn, true)) return;
      var rebuyAtAdd = rebuyReady();
      const currentId = $(this).attr('data-id');
      const currentQty = 1;
      const items = [tagLine({ id: currentId, quantity: currentQty }, this, 'buy_section_addon')];

      $.post('/cart/add.js', { items: items }, function () {
        setBusy(btn, false);
        afterAdd(rebuyAtAdd);
      }, 'json').fail(function () {
        setBusy(btn, false);
        alert('Error adding item to the cart.');
      });
    });

    $('.bb-product-atc_primary').click(function () {
      var btn = this;
      if (!setBusy(btn, true)) return;
      var rebuyAtAdd = rebuyReady();
      const currentId = $(this).attr('data-id');
      // data-qty is written by the lp-buybox quantity selector; elsewhere it is absent and the quantity is 1.
      const currentQty = parseInt($(this).attr('data-qty'), 10) || 1;
      const items = [tagLine({ id: currentId, quantity: currentQty }, this, 'buy_section')].concat(addonLines());

      $.post('/cart/add.js', { items: items }, function () {
        setBusy(btn, false);
        afterAdd(rebuyAtAdd);
      }, 'json').fail(function () {
        setBusy(btn, false);
      });
    });

    $(document).on("click", ".bolde_item-additional-product--atc", function (evt) {

      $(this).closest('.cd_content').find('.cd_item').addClass('loading');
      evt.preventDefault();
      var $btn = $(this);
      var currentId = $btn.attr('data-id');

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: currentId,
          quantity: 1
        },
        success: function () {
          refreshCartDrawer();
        }
      });
    });


    $(document).on("click", ".bolde_cart_upsell_btn", function (evt) {
      evt.preventDefault();
      var $btn = $(this);
      $btn.find('.upsell_btn_content').hide();
      $btn.find('.upsell_btn_loader').css('display', 'block');

      var mode = $btn.attr('data-mode');
      var currentId = $btn.attr('data-id');
      var currentQty = 1;

      var upsellSource = (mode === 'pp') ? 'Upsell from product page' : 'Upsell from cart';

      var data = {
        id: currentId,
        quantity: currentQty
      };

      console.log("Adding upsell product:", data);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(response => response.json())
        .then(cart => {
          console.log("Upsell product added:", cart);

          return fetch('/cart.js')
            .then(response => response.json());
        })
        .then(cartData => {
          console.log("Cart data before attribute update:", cartData);

          let updatedAttributes = cartData.attributes || {};
          updatedAttributes["Upsell Source"] = upsellSource;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: updatedAttributes })
          });
        })
        .then(response => response.json())
        .then(updatedCart => {
          console.log("Cart updated with Upsell Source:", updatedCart);

          if (mode === 'pp') {
            $('.cd_outer').show();
            setTimeout(() => $('.cd_outer').addClass('active'), 100);
          }

          refreshCartDrawer();
          $btn.find('.upsell_btn_content').show();
          $btn.find('.upsell_btn_loader').hide();
          $('.col_pp_upsell_outer').hide();
        })
        .catch(error => {
          console.error('Upsell error:', error);
          alert('Something went wrong. Please try again.');
        });
    });

    $(document).on("click", ".cd_item_upgrade_to_sub", function (evt) {
      $(this).html('Upgrading...');

      var currentId = $(this).attr('data-id');
      var newSellingPlanId = $(this).attr('data-selling-plan-id');
      var oldId = $(this).attr('data-old-id');

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          id: currentId,
          quantity: 1,
          selling_plan: newSellingPlanId
        },
        success: function () {

          $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: {
              id: oldId,
              quantity: 0
            },
            success: function () {
              refreshCartDrawer();
            }
          });
        }
      });
    });


    $(".col_pp_Atc_main__js").click(function () {
      var rebuyAtAdd = rebuyReady();
      $(this).addClass('loading');
      var currentMode = $(".col_product-mode.active").attr("data");
      var currentId;
      var data;
      var sellingId = $(".col_product_variant.active").attr("data-selling-plan");
      if (currentMode == "sub") {
        currentId = $(".col_product_variant.active").attr("data-sub-id");
        data = {
          id: currentId,
          quantity: 1,
          selling_plan: sellingId,
        };
      } else {
        currentId = $(".col_product_variant.active").attr("data-id");
        data = {
          id: currentId,
          quantity: 1,
        };
      }

      console.log(data);



      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          afterAdd(rebuyAtAdd);
        },
        error: function () {
          alert('Error adding item to the cart.');
          $(".col_pp_Atc_main__js").removeClass('loading');
        }
      });
    });

    $('.cd_outer').click(function (e) {
      if (!$(e.target).closest('.cd_inner').length) {
        $('.cd_outer').removeClass('active');
        setTimeout(function () {
          $('.cd_outer').hide();
        }, 500);
      }
    });

    $(document).on("click", ".cd_close", function () {
      $('.cd_outer').removeClass('active');
      setTimeout(function () {
        $('.cd_outer').hide();
      }, 500);
    });


    $(document).on("click", ".cd_item-plus", function () {
      $(this).closest('.cd_item').addClass('loading');
      var currentVal = parseFloat($(this).closest('.cd_item').find('.cd_item-val').html());
      currentVal++;
      var currentId = $(this).closest('.cd_item').attr('data-id');

      var data = {
        "id": currentId,
        "quantity": currentVal
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function () {
          console.log(data);
          refreshCartDrawer();
        }
      });
    });

    $(document).on("click", ".cd_item-remove", function () {
      $(this).closest('.cd_item').addClass('loading');
      var currentId = $(this).closest('.cd_item').attr('data-id');

      var data = {
        "id": currentId,
        "quantity": 0
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function () {
          console.log(data);
          refreshCartDrawer();
        }
      });
    });

    $(document).on("click", ".cd_item-minus", function () {
      $(this).closest('.cd_item').addClass('loading');
      var currentVal = parseFloat($(this).closest('.cd_item').find('.cd_item-val').html());
      currentVal--;
      var currentId = $(this).closest('.cd_item').attr('data-id');

      var data = {
        "id": currentId,
        "quantity": currentVal
      }

      jQuery.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: data,
        dataType: 'json',
        success: function () {
          console.log(data);
          refreshCartDrawer();
        }
      });
    });
  });
})();
